import React from 'react';
function Footer () {
    return(
        <div className="footer"><p>© Copyright {new Date().getFullYear()}. All rights reserved.</p></div>
    );
}
export default Footer;